import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type PasswordRotationConfig = typeof PasswordRotationConfig._.Config;

export const PasswordRotationConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.PasswordRotation,
  configSchema: z.object({
    rotationDays: z.number(),
    userNamePatternFilter: patternFilterSchema.optional(),
  }),
});
